import { render, staticRenderFns } from "./claimResponsibilityDetail.vue?vue&type=template&id=1ec3c618&scoped=true"
import script from "./claimResponsibilityDetail.vue?vue&type=script&lang=js"
export * from "./claimResponsibilityDetail.vue?vue&type=script&lang=js"
import style0 from "./claimResponsibilityDetail.vue?vue&type=style&index=0&id=1ec3c618&prod&lang=scss&scoped=true"
import style1 from "./claimResponsibilityDetail.vue?vue&type=style&index=1&id=1ec3c618&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec3c618",
  null
  
)

export default component.exports